import useTrackWithUser from 'api/hooks/useTrackWithUser';
import { useEffect } from 'react';

export default function useTrackPage(eventName) {
  const [trackPageEvent] = useTrackWithUser(eventName);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => trackPageEvent(), []);
}
